import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-2 mt-2 lg:mt-0 rounded shadow bg-white" }
const _hoisted_2 = { class: "p-6" }
const _hoisted_3 = { class: "text-xl font-bold" }
const _hoisted_4 = { class: "pt-2 text-gray-600 text-xs lg:text-sm flex items-center justify-center lg:justify-start" }
const _hoisted_5 = { class: "pt-2 text-gray-600 text-xs lg:text-sm flex items-center justify-center lg:justify-start" }
const _hoisted_6 = { class: "pt-2 text-gray-600 text-xs lg:text-sm flex items-center justify-center lg:justify-start" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = { class: "pt-2 text-gray-600 text-xs lg:text-sm flex items-center justify-center lg:justify-start" }
const _hoisted_9 = { class: "flex justify-start items-start my-4" }
const _hoisted_10 = { class: "p-2 mt-2 rounded shadow bg-white" }
const _hoisted_11 = {
  key: 0,
  class: "flex flex-col mt-4"
}
const _hoisted_12 = { class: "text-right col-span-full" }
const _hoisted_13 = {
  key: 1,
  class: "min-w-full divide-y divide-gray-200"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("thead", { class: "bg-gray-50" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-xs font-medium tracking-wider text-left text-gray-500 uppercase"
    }, " 店舗名 "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-xs font-medium tracking-wider text-left text-gray-500 uppercase"
    }, " スタッフ数 "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-xs font-medium tracking-wider text-left text-gray-500 uppercase"
    }, " ユーザー数 "),
    /*#__PURE__*/_createElementVNode("th")
  ])
], -1)
const _hoisted_15 = { class: "bg-white divide-y divide-gray-200" }
const _hoisted_16 = { class: "px-6 py-4 text-sm text-gray-500 whitespace-nowrap" }
const _hoisted_17 = { class: "px-6 py-4 text-sm text-gray-500 whitespace-nowrap" }
const _hoisted_18 = { class: "px-6 py-4 text-sm text-gray-500 whitespace-nowrap" }
const _hoisted_19 = { class: "flex justify-start items-center" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = {
  key: 2,
  class: "min-w-full divide-y divide-gray-200"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("thead", { class: "bg-gray-50" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-xs font-medium tracking-wider text-left text-gray-500 uppercase"
    }, " 名前 "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-xs font-medium tracking-wider text-left text-gray-500 uppercase"
    }, " 店舗名 "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-xs font-medium tracking-wider text-left text-gray-500 uppercase"
    }, " ユーザー数 "),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" })
  ])
], -1)
const _hoisted_23 = { class: "bg-white divide-y divide-gray-200" }
const _hoisted_24 = { class: "px-6 py-4 text-sm text-gray-500 whitespace-nowrap" }
const _hoisted_25 = { class: "px-6 py-4 text-sm text-gray-500 whitespace-nowrap" }
const _hoisted_26 = { class: "px-6 py-4 text-sm text-gray-500 whitespace-nowrap" }
const _hoisted_27 = {
  key: 3,
  class: "flex flex-col mt-4"
}
const _hoisted_28 = { class: "text-right col-span-full" }
const _hoisted_29 = {
  key: 4,
  class: "min-w-full divide-y divide-gray-200"
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("thead", { class: "bg-gray-50" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-xs font-medium tracking-wider text-left text-gray-500 uppercase"
    }, " 名前 "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-xs font-medium tracking-wider text-left text-gray-500 uppercase"
    }, " メールアドレス "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-xs font-medium tracking-wider text-left text-gray-500 uppercase"
    }, " 代表 "),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" })
  ])
], -1)
const _hoisted_31 = { class: "bg-white divide-y divide-gray-200" }
const _hoisted_32 = { class: "px-6 py-4 text-sm text-gray-500 whitespace-nowrap" }
const _hoisted_33 = { class: "px-6 py-4 text-sm text-gray-500 whitespace-nowrap" }
const _hoisted_34 = { class: "px-6 py-4 text-sm text-gray-500 whitespace-nowrap" }
const _hoisted_35 = { class: "flex justify-start items-center" }
const _hoisted_36 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fa = _resolveComponent("fa")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h1", _hoisted_3, " 【" + _toDisplayString(_ctx.salon.id) + "】" + _toDisplayString(_ctx.salon.name) + " (" + _toDisplayString(_ctx.salon.kana) + ") ", 1),
        _createElementVNode("p", _hoisted_4, [
          _createElementVNode("span", null, [
            _createVNode(_component_fa, {
              icon: "map-marked-alt",
              class: "text-sm text-color-3 mr-2"
            })
          ]),
          _createTextVNode(" " + _toDisplayString(`${_ctx.salon.prefecture || ''}${_ctx.salon.city || ''}${_ctx.salon.address || ''}${_ctx.salon.building || ''}`), 1)
        ]),
        _createElementVNode("p", _hoisted_5, [
          _createElementVNode("span", null, [
            _createVNode(_component_fa, {
              icon: "phone",
              class: "text-sm text-color-3 mr-2"
            })
          ]),
          _createTextVNode(" " + _toDisplayString(_ctx.salon.telephone), 1)
        ]),
        _createElementVNode("p", _hoisted_6, [
          _createElementVNode("span", null, [
            _createVNode(_component_fa, {
              icon: "university",
              class: "text-sm text-color-3 mr-2"
            })
          ]),
          _createTextVNode(" " + _toDisplayString(_ctx.salon.bank_name) + " " + _toDisplayString(_ctx.salon.branch_name), 1),
          _hoisted_7,
          _createTextVNode(" " + _toDisplayString(_ctx.formatAccountType(_ctx.salon.account_type)) + " " + _toDisplayString(_ctx.salon.account_no) + " " + _toDisplayString(_ctx.salon.account_name), 1)
        ]),
        _createElementVNode("p", _hoisted_8, [
          _createElementVNode("span", null, [
            _createVNode(_component_fa, {
              icon: "industry",
              class: "text-sm text-color-3 mr-2"
            })
          ]),
          _createTextVNode(" " + _toDisplayString(_ctx.salon.dealer_name), 1)
        ])
      ])
    ]),
    _createElementVNode("ul", _hoisted_9, [
      _createElementVNode("li", {
        class: _normalizeClass(["cursor-pointer py-2 px-4 text-gray-500 border-b-8 border-gray-500 w-1/3 text-center mx-1", _ctx.selected_tab === 'shops' ? 'text-color-3 border-color-3' : '']),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selected_tab = 'shops')),
        "x-text": "tab"
      }, " 店舗 ", 2),
      _createElementVNode("li", {
        class: _normalizeClass(["cursor-pointer py-2 px-4 text-gray-500 border-b-8 border-gray-500 w-1/3 text-center mx-1", _ctx.selected_tab === 'staffs' ? 'text-color-3 border-color-3' : '']),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selected_tab = 'staffs')),
        "x-text": "tab"
      }, " スタッフ ", 2),
      _createElementVNode("li", {
        class: _normalizeClass(["cursor-pointer py-2 px-4 text-gray-500 border-b-8 border-gray-500 w-1/3 text-center mx-1", 
        _ctx.selected_tab === 'administrators' ? 'text-color-3 border-color-3' : ''
      ]),
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selected_tab = 'administrators')),
        "x-text": "tab"
      }, " 管理者 ", 2)
    ]),
    _createElementVNode("div", _hoisted_10, [
      (_ctx.selected_tab == 'shops')
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_router_link, {
                to: `/salons/${_ctx.$route.params.salon_id}/shops/register`,
                class: "px-4 py-2 text-sm font-medium text-white border border-transparent rounded-md shadow-sm bg-color-3 hover:bg-color-3 focus:outline-none focus:ring-3 focus:ring-offset-3 focus:ring-color-3"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 新規登録 ")
                ]),
                _: 1
              }, 8, ["to"])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.selected_tab == 'shops')
        ? (_openBlock(), _createElementBlock("table", _hoisted_13, [
            _hoisted_14,
            _createElementVNode("tbody", _hoisted_15, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.shops, (shop) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: shop.id,
                  class: _normalizeClass({ 'bg-gray-100': shop.deleted_at })
                }, [
                  _createElementVNode("td", _hoisted_16, _toDisplayString(shop.name) + " (" + _toDisplayString(shop.kana) + ") ", 1),
                  _createElementVNode("td", _hoisted_17, _toDisplayString(shop.staff_count), 1),
                  _createElementVNode("td", _hoisted_18, _toDisplayString(shop.user_count), 1),
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_19, [
                      (!shop.deleted_at)
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 0,
                            class: "bg-blue-500 hover:bg-blue-700 text-white py-1 px-2 rounded-full h-8 w-8 flex justify-center items-center mr-2",
                            style: {"height":"24px","width":"24px"},
                            to: `/salons/${_ctx.salon.id}/shops/${shop.id}/edit`
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_fa, {
                                icon: "pen",
                                class: "text-xs"
                              })
                            ]),
                            _: 2
                          }, 1032, ["to"]))
                        : _createCommentVNode("", true),
                      (!shop.deleted_at && !shop.is_main)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            class: "bg-red-500 hover:bg-red-700 text-white py-1 px-2 rounded-full h-8 w-8 flex justify-center items-center",
                            style: {"height":"24px","width":"24px"},
                            onClick: ($event: any) => (_ctx.onConfirmDeleteShop(shop))
                          }, [
                            _createVNode(_component_fa, {
                              icon: "trash",
                              class: "text-xs"
                            })
                          ], 8, _hoisted_20))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ], 2))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.selected_tab == 'staffs')
        ? (_openBlock(), _createElementBlock("table", _hoisted_21, [
            _hoisted_22,
            _createElementVNode("tbody", _hoisted_23, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.staffs, (staff) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: staff.id
                }, [
                  _createElementVNode("td", _hoisted_24, _toDisplayString(staff.name) + " (" + _toDisplayString(staff.kana) + ") ", 1),
                  _createElementVNode("td", _hoisted_25, _toDisplayString(staff.shop_name), 1),
                  _createElementVNode("td", _hoisted_26, _toDisplayString(staff.user_count), 1)
                ]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.selected_tab == 'administrators')
        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              _createVNode(_component_router_link, {
                to: `/salons/${_ctx.$route.params.salon_id}/administrators/register`,
                class: "px-4 py-2 text-sm font-medium text-white border border-transparent rounded-md shadow-sm bg-color-3 hover:bg-color-3 focus:outline-none focus:ring-3 focus:ring-offset-3 focus:ring-color-3"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 新規登録 ")
                ]),
                _: 1
              }, 8, ["to"])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.selected_tab == 'administrators')
        ? (_openBlock(), _createElementBlock("table", _hoisted_29, [
            _hoisted_30,
            _createElementVNode("tbody", _hoisted_31, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.administrators, (administrator) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: administrator.id
                }, [
                  _createElementVNode("td", _hoisted_32, _toDisplayString(administrator.name), 1),
                  _createElementVNode("td", _hoisted_33, _toDisplayString(administrator.email), 1),
                  _createElementVNode("td", _hoisted_34, _toDisplayString(administrator.is_main ? "◯" : ""), 1),
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_35, [
                      (!administrator.deleted_at)
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 0,
                            class: "bg-blue-500 hover:bg-blue-700 text-white py-1 px-2 rounded-full h-8 w-8 flex justify-center items-center mr-2",
                            style: {"height":"24px","width":"24px"},
                            to: `/salons/${_ctx.salon.id}/administrators/${administrator.id}/edit`
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_fa, {
                                icon: "pen",
                                class: "text-xs"
                              })
                            ]),
                            _: 2
                          }, 1032, ["to"]))
                        : _createCommentVNode("", true),
                      (!administrator.deleted_at && !administrator.is_main)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            class: "bg-red-500 hover:bg-red-700 text-white py-1 px-2 rounded-full h-8 w-8 flex justify-center items-center",
                            style: {"height":"24px","width":"24px"},
                            onClick: ($event: any) => (_ctx.onConfirmDeleteAdministrator(administrator))
                          }, [
                            _createVNode(_component_fa, {
                              icon: "trash",
                              class: "text-xs"
                            })
                          ], 8, _hoisted_36))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.is_confirming)
      ? (_openBlock(), _createBlock(_component_ConfirmDialog, {
          key: 0,
          title: _ctx.dialog_title,
          message: _ctx.dialog_message,
          onOk: _ctx.onDelete,
          onCancel: _ctx.onCancelDeletion
        }, null, 8, ["title", "message", "onOk", "onCancel"]))
      : _createCommentVNode("", true)
  ], 64))
}